export const SMS_ENTRY_POINT_STORAGE = 'sms_entry_indicator_this_session'
